export default __webpack_public_path__ + "static/media/p02 p03.01eb3f3e.jpg";